import { AreaInfoInterface } from '../hooks/usePlanFreeHelper'
import { infoPages } from '../utils/dummy'

interface FreeHomeProps {
  link: string
}

export default function HomePagePlanFree({ link }: FreeHomeProps) {
  let params: AreaInfoInterface

  switch (link) {
    case 'stocks':
      params = infoPages.almacenes
      break
    case 'products':
      params = infoPages.productos
      break
    case 'ecocycle':
      params = infoPages.ciclosEconómicos
      break
    case 'users':
      params = infoPages.recursosHumanos
      break
    case 'clients':
      params = infoPages.clientes
      break
    default:
      params = infoPages.inicio
      break
  }

  return (
    <div className="overflow-hidden bg-white">
      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="absolute bottom-0 left-3/4 top-0 hidden w-screen bg-gray-50 lg:block" />
        <div className="mx-auto max-w-prose text-base lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-8">
          <div>
            <h3 className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
              {params.title}
            </h3>
          </div>
        </div>
        <div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-8">
          <div className="relative lg:col-start-2 lg:row-start-1">
            <svg
              aria-hidden="true"
              className="absolute right-0 top-0 -mr-20 -mt-20 hidden lg:block"
              fill="none"
              height={384}
              viewBox="0 0 404 384"
              width={404}
            >
              <defs>
                <pattern
                  height={20}
                  id="de316486-4a29-4312-bdfc-fbce2132a2c1"
                  patternUnits="userSpaceOnUse"
                  width={20}
                  x={0}
                  y={0}
                >
                  <rect
                    className="text-gray-200"
                    fill="currentColor"
                    height={4}
                    width={4}
                    x={0}
                    y={0}
                  />
                </pattern>
              </defs>
              <rect
                fill="url(#de316486-4a29-4312-bdfc-fbce2132a2c1)"
                height={384}
                width={404}
              />
            </svg>
            <div className="relative mx-auto max-w-prose text-base lg:max-w-none">
              <figure>
                <div className="aspect-h-9 aspect-w-14">
                  <img
                    alt=""
                    className="rounded-lg object-cover object-center"
                    height={2376}
                    src={params.image ?? ''}
                    width={4884}
                  />
                </div>
              </figure>
            </div>
          </div>
          <div className="mt-8 lg:mt-0">
            <div className="mx-auto max-w-prose text-base lg:max-w-none">
              <p className="text-lg text-gray-500">{params.text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
